import moment from 'moment';

import { SalesOrderInfo } from '../../../store/slices/salesOrders';
import styles from './PatientInfoHeader.module.scss';
import { useTranslation } from '../../../hooks/useTranslations';
type Props = {
  selectedListOrder: SalesOrderInfo;
};

const PatientInfoHeader: React.FC<Props> = ({ selectedListOrder }) => {
  const { translations } = useTranslation();
  if (!selectedListOrder) return <div></div>;
  return (
    <div>
      <div className={styles.name}>
        {selectedListOrder.customer_person.person_firstname}{' '}
        {selectedListOrder.customer_person.person_lastname}
      </div>
      <div className={styles.description}>
        ID: {selectedListOrder.customer_person.person_id} {selectedListOrder.product.product_name}{' '}
        <span>|</span>
        {selectedListOrder.sales_order_appointment.start
          ? moment(selectedListOrder.sales_order_appointment.start).format(' DD.MMMM.YYYY')
          : translations('walkin_appointment')}
        <span>|</span>
        {selectedListOrder.sales_order_appointment.start
          ? moment(selectedListOrder.sales_order_appointment.start).format('HH:mm') +
            moment(selectedListOrder.sales_order_appointment.end_time).format(' - HH:mm')
          : ''}
      </div>
    </div>
  );
};
export { PatientInfoHeader };
